import './Users.scss'

import { useCharacters } from "../../../contexts/Characters"
import { useEffect, useRef, useState } from 'react'
import { deepMatch } from '../../../utilities/helpers'
import { Roles } from '../../../utilities/constants'
import { Link, useNavigate } from 'react-router'
import Input from '../../forms/Input/Input'
import Select from '../../forms/Select/Select'
import koalition from '../../../api/koalition'
import { useToaster } from '../../../contexts/Toaster'
import { useData } from '../../../contexts/Data'

const Users = () => {
    const navigate = useNavigate()
    const characters = useCharacters()
    const toaster = useToaster()
    const data = useData()
    const [visibleUsers, setVisibleUsers] = useState([])
    const [filterKey, setFilterKey] = useState()
    const [advancedFiltersVisible, setAdvancedFiltersVisible] = useState(false)
    const [discordIdFilter, setDiscordIdFilter] = useState(undefined)
    const [charactersFilter, setCharactersFilter] = useState(undefined)

    const discordIdFilterOptions = [
        { value: undefined, label: 'Any' },
        { value: false, label: 'Without Discord Id' },
        { value: true, label: 'With Discord Id' },
    ]

    const charactersFilterOptions = [
        { value: undefined, label: 'Any' },
        { value: false, label: 'Without Characters' },
        { value: true, label: 'With Characters' },
    ]

    const filterVisibleUsers = () => {
        if (data.$state.users) {
            const filteredUsers = data.$state.users.filter((user) => {
                const emailMatch = !filterKey || user.email && user.email.toLowerCase().includes(filterKey.toLowerCase())
                const discordIdMatch = !filterKey || user.discordId && `${user.discordId}`.includes(filterKey)
                const searchMatch = emailMatch || discordIdMatch
    
                const discordIdFilterMatch = discordIdFilter === undefined || (discordIdFilter === false && !user.discordId) || (discordIdFilter && user.discordId)
                const charactersMatch = charactersFilter === undefined || (charactersFilter === false && !user.characters?.length) || (charactersFilter && user.characters?.length)
                
                return searchMatch && discordIdFilterMatch && charactersMatch
            })
    
            setVisibleUsers(filteredUsers)
        }
    }
    
    useEffect(() => {
        filterVisibleUsers()
    }, [filterKey, discordIdFilter, charactersFilter, data.$state.users])

    useEffect(() => {
        if (characters.$state.current && !data.$state.users?.length) koalition.get('/users').then((response) => {
            data.save('users', response.data)
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
            data.save('users', [])
        })
    }, [characters.$state.current])

    return (
        <div className="container-fluid manage-users">
            <div className="row">
                <div className="col col-xl-4 mb-3">
                    <Input onChange={setFilterKey} placeholder="Filter" />
                </div>
                <div className="col col-xl-4 mb-3 pl-0">
                    <Select options={discordIdFilterOptions} onChange={setDiscordIdFilter} placeholder="Discord Id" />
                </div>
                <div className="col col-xl-4 mb-3 pl-0">
                    <Select options={charactersFilterOptions} onChange={setCharactersFilter} placeholder="Characters" />
                </div>
                {/* <div className="col-auto pl-0">
                    <button className="primary medium icon" onClick={() => setAdvancedFiltersVisible(!advancedFiltersVisible)}>
                        <img src="/images/icons/filter.svg" />
                    </button>
                </div> */}
            </div>
            {/* {advancedFiltersVisible && (
                <div className="row">
                    <div className="col col-xl-4 mb-3">
                        
                    </div>
                </div>
            )} */}
            <ul className="row mt-4 pr-4">
                {visibleUsers.map((user) => (
                    <li className="col-sm-6 col-md-4 col-lg-3 pr-0" key={user._id}>
                        <Link to={`/users/${user._id}`}>
                            <span className="card user flex-center cursor-pointer mb-4">
                                <span>{user.email || user.discordId}</span>
                            </span>
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default Users